<!-- navbar header start -->

<header class="header-area transparent">
    <div class="container">
        <div class="row no-gutter align-items-center position-relative">
            <div class="col-12">
                <div class="header-align">
                    <div class="header-align-start">
                        <div class="header-logo-area">
                            <a href="index.html" id="landingpageimage_path">
                                <img class="logo-main" src="../../../../assets/images/new-images/OUK_Logo 1.png"
                                    alt="Logo" />

                                <img class="logo-light" src="../../../../assets/images/new-images/OUK_Logo 1.png"
                                    alt="Logo" />
                            </a>
                        </div>
                    </div>

                    <div class="header-align-center">
                        <div class="header-navigation-area position-relative">
                            <ul class="main-menu nav mb-0">
                                <li><a routerLink="/"><span>Home</span></a></li>

                                <li><a [routerLink]="['/home']" fragment="about">About</a></li>

                                <li><a routerLink="/menu/jobs"><span>Jobs</span></a></li>
                                <li><a routerLink="/menu/internships"><span>Internships</span></a></li>
                                <li><a routerLink="/menu/corporates"><span>Corporates</span></a></li>

                                <li><a routerLink="/menu/contact"><span>Contact</span></a></li>
                                <!-- <li><a routerLink="/menu/startsUp"><span>Starts Up</span></a></li> -->







                                <!-- <li class="has-submenu"><a href="#/"><span>Jobs</span></a>
                                    <ul class="submenu-nav">
                                        <li><a href="#"><span>Job Categories </span></a></li>
                                        <li><a href="#"><span>Job Listings </span></a></li>
                                        <li><a href="#"><span>Job Detail </span></a></li>
                                    </ul>
                                </li> -->


                                <!-- 
                                <li><a href="#"><span>Job Apply </span></a></li>
                                <li><a href="#"><span>Job Post </span></a></li>
 -->







                                <!-- <li class="has-submenu"><a href="#/"><span>Find Jobs</span></a>
                                    <ul class="submenu-nav">
                                        <li><a href="job.html"><span>Jobs</span></a></li>
                                        <li><a href="job-details.html"><span>Job Details</span></a></li>
                                    </ul>
                                </li>
                                <li><a href="employers-details.html"><span>Employers Details</span></a></li>
                                <li class="has-submenu"><a href="#/"><span>Candidates</span></a>
                                    <ul class="submenu-nav">
                                        <li><a href="candidate.html"><span>Candidates</span></a></li>
                                        <li><a href="candidate-details.html"><span>Candidate Details</span></a></li>
                                    </ul>
                                </li>
                                <li class="has-submenu"><a href="#/"><span>Blog</span></a>
                                    <ul class="submenu-nav">
                                        <li><a href="blog-grid.html">Blog Grid</a></li>
                                        <li><a href="blog.html">Blog Left Sidebar</a></li>
                                        <li><a href="blog-right-sidebar.html">Blog Right Sidebar</a></li>
                                        <li><a href="blog-details.html">Blog Details</a></li>
                                    </ul>
                                </li>
                                <li class="has-submenu"><a href="#/"><span>Pages</span></a>
                                    <ul class="submenu-nav">
                                        <li><a href="about-us.html"><span>About us</span></a></li>
                                        <li><a href="login.html"><span>Login</span></a></li>
                                        <li><a href="registration.html"><span>Registration</span></a></li>
                                        <li><a href="page-not-found.html"><span>Page Not Found</span></a></li>
                                    </ul>
                                </li> -->
                                <!-- <li><a href="contact.html"><span>Contact</span></a></li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="header-align-end">
                        <div class="header-action-area">


                            <!-- <li class="nav-item">
                                <a class="nav-link btn-login" aria-current="page" [routerLink]="['/login']">Login</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link btn btn-signup  py-2 mt-2" style="font-weight: 600;" type="button"
                                    (click)="NavigateTo()" aria-current="page">Signup</a>
                            </li> -->


                            <a class="btn-registration w-auto ps-3 pe-3 " aria-current="page" [routerLink]="['/login']">
                                Login</a> &nbsp;
                            <!-- <a class="btn-registration w-auto ps-3 pe-3" aria-current="page" type="button"
                                (click)="NavigateTo()" aria-current="page"> Signup</a> -->
                            <a class="btn-registration w-auto ps-3 pe-3" data-bs-toggle="modal"
                                data-bs-target="#signupModal">
                                Signup</a>
                            <button class="btn-menu" type="button" data-bs-toggle="offcanvas"
                                data-bs-target="#AsideOffcanvasMenu" aria-controls="AsideOffcanvasMenu">
                                <i class="icofont-navigation-menu"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<!-- 

<header>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white shadow-lg">
        <div class="container">
            <a class="navbar-brand text-white " href="#"> <img class="samvaad-logo w-25" id="landingpageimage_path"
                    src="../../../../assets/img/logo1-new.png" alt="samvaad Tutor"></a>
            <a class="navbar-toggler border-3 px-2" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                <i class="fa-solid fa-bars"></i>
            </a>
            <div class="offcanvas offcanvas-start-lg bg-nav" tabindex="-1" id="offcanvasExample"
                aria-labelledby="offcanvasExampleLabel">
                <div class="offcanvas-header  d-lg-none">
                    <h5 class="offcanvas-title text-white" id="offcanvasExampleLabel"><img class="samvaad-logo"
                            id="landingpageimage_path" src="../../../../assets/img/logo1-new.png" alt="samvaad Tutor">
                    </h5>
                    <a href="javascript:void(0) " class="text-reset p-0" data-bs-dismiss="offcanvas" aria-label="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#FFFFFF"
                            class="bi bi-x-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                    </a>

                </div>
                <div class="offcanvas-body p-lg-0 ">
                    <ul class="navbar-nav">
                  
                        <li class="nav-item d-block d-xl-none d-lg-none">
                            <div class="text-center text-dark"><img src="assets/img/avtar.png"
                                    class="img-fluid rounded-circle border" alt="" height="50px" width="50px"> </div>
                            <a class="nav-link btn-login text-center py-2" style="padding-right: 0 !important;"
                                aria-current="page" [routerLink]="['/login']"><button
                                    class="btn btn-sm btn_white">Login</button></a>
                        </li>

                    </ul>
                    <ul class="navbar-nav ms-xl-auto ms-md-auto">
                        <li class="nav-item d-xl-block d-lg-block d-none py-2">
                          
                            <i id="search-btn" class="fa fa-search fa-sm mt-1"></i>
                            <div id="search-overlay" class="search_block">
                                <div class="centered">
                                    <div id='search-box'>
                                        <i id="close-btn" class="fa fa-times fa-2x"></i>
                                        <form action='/search' id='search-form' method='get' target='_top'>
                                            <input id='search-text' name='q' placeholder='Search' type='text' />
                                            <button id='search-button' type='submit'>
                                                <span>Search</span>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                       
                        </li>

                        <li class="nav-item">
                            <a class="nav-link btn-login" aria-current="page" [routerLink]="['/login']">Login</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link btn btn-signup  py-2 mt-2" style="font-weight: 600;" type="button"
                                (click)="NavigateTo()" aria-current="page">Signup</a>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </nav>
</header> -->
<!-- Modal Structure -->
<div class="modal fade" id="signupModal" tabindex="-1" aria-labelledby="signupModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="signupModalLabel">Signup 3</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" id="cls" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <!-- Signup form or content -->
                <label for="floatingSelectDisabled">I am a</label>
                <div class="">
                    <select class="form-select" (change)="signUPLogin($any($event.target).value)">
                        <option>Select</option>
                        <option value="1">Company</option>
                        <option value="2">Job Seeker</option>
                        <option value="3">Founder</option>
                        <option value="4">Incubator</option>
                        <option value="5">Investor</option>
                    </select>

                </div>


            </div>

            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Submit</button>
            </div> -->

        </div>
    </div>
</div>